import { useNavigate } from "react-router-dom"

import Style from "./style"

import Banner from "widget/Banner"

import useGetSeriesDetail from "entity/event/useGetSeriesDetail"

import { convertEventStateAsName } from "shared/constant/lookup/eventState"
import { convertEventTypeAsName } from "shared/constant/lookup/eventType"
import timestampCalculator from "shared/lib/timestampCalculator"
import convertMoney from "shared/lib/convertMoney"

const SeriesDetail = () => {
    const navigate = useNavigate()

    const [seriesData] = useGetSeriesDetail()

    return (
        <Style.Wrapper>

            <Banner imgList={seriesData?.data?.series?.img_list} />

            <Style.ContentDiv>

                <Style.HeaderDiv>
                    <Style.ContentElement>
                        <Style.TitleDiv>
                            <h2>{seriesData?.data?.series?.name}</h2>
                        </Style.TitleDiv>
                        <p>시리즈 기간 : {timestampCalculator(seriesData?.data?.series?.start_date, "date")} ~ {timestampCalculator(seriesData?.data?.series?.end_date, "date")}</p>
                    </Style.ContentElement>
                    {
                        (seriesData?.data?.series?.total_gtd || seriesData?.data?.series?.main_gtd) &&
                        <Style.ContentElement>
                            {seriesData?.data?.series?.total_gtd &&
                                <p><span>전체 GTD</span>{convertMoney(seriesData?.data?.series?.total_gtd)}</p>
                            }
                            {seriesData?.data?.series?.main_gtd &&
                                <p><span>메인 이벤트 GTD</span>{convertMoney(seriesData?.data?.series?.main_gtd)}</p>
                            }
                        </Style.ContentElement>
                    }
                    <h2>{seriesData?.data?.series?.content}</h2>
                </Style.HeaderDiv>

                <Style.Area>
                    <h2>시리즈 일정</h2>
                    <Style.EventList>
                        {seriesData?.data?.official_event?.map(elem =>
                            <Style.EventElement onClick={() => navigate(`/event/${elem?.idx}/detail`)}>
                                {elem?.img_list?.length > 0 &&
                                    <img src={elem?.img_list[0]} />
                                }
                                <Style.ShadowDiv />
                                <Style.EventTitleDiv $state={elem?.event_state_flag}>
                                    <h1>{elem?.name}</h1>
                                    <p>{timestampCalculator(elem?.date)}</p>
                                    <h2>{convertEventStateAsName[elem?.event_state_flag]}</h2>
                                </Style.EventTitleDiv>
                                <Style.EventControlDiv $type={elem?.event_type_flag}>
                                    <p>{convertEventTypeAsName[elem?.event_type_flag]}</p>
                                </Style.EventControlDiv>
                            </Style.EventElement>
                        )}
                        {seriesData?.data?.official_event?.length < 1 && <Style.Option>아직 대회가 생성되지 않았습니다.</Style.Option>}
                    </Style.EventList>
                </Style.Area>

                <Style.Area>
                    <h2>시드권을 얻을 수 있는 게임</h2>
                    <Style.EventList>
                        {seriesData?.data?.preliminary_event?.map(elem =>
                            <Style.EventElement onClick={() => navigate(`/event/${elem?.idx}/detail`)}>
                                {elem?.img_list?.length > 0 &&
                                    <img src={elem?.img_list[0]} />
                                }
                                <Style.ShadowDiv />
                                <Style.EventTitleDiv $state={elem?.event_state_flag}>
                                    <h1>{elem?.name}</h1>
                                    <p>{timestampCalculator(elem?.date)}</p>
                                    <h2>{convertEventStateAsName[elem?.event_state_flag]}</h2>
                                </Style.EventTitleDiv>
                                <Style.EventControlDiv $type={elem?.event_type_flag}>
                                    <p>{convertEventTypeAsName[elem?.event_type_flag]}</p>
                                </Style.EventControlDiv>
                            </Style.EventElement>
                        )}
                        {seriesData?.data?.preliminary_event?.length < 1 && <Style.Option>아직 대회가 생성되지 않았습니다.</Style.Option>}
                    </Style.EventList>
                </Style.Area>

            </Style.ContentDiv>

        </Style.Wrapper>

    )
}

export default SeriesDetail